import PropTypes from 'prop-types'

import { SectionTitle, CodeWrapper } from 'components/common/Codeblock'
import { OnboardingLink } from 'components/common/OnboardingLink'
import TrackedExternalLink from 'components/common/TrackedExternalLink'
import theme from 'theme'

const DockerImage = ({ colorTheme, ...rest }) => (
  <CodeWrapper {...rest}>
    <div css={{ paddingBottom: theme.space[2] }}>
      <div css={{ display: 'flex', alignItems: 'flex-end' }}>
        <div>
          <SectionTitle colorTheme={colorTheme}>
            Instead of installing Gremlin directly on the host operating system,
            you can deploy Gremlin from{' '}
            <OnboardingLink
              as={TrackedExternalLink}
              css={{ textDecoration: 'underline' }}
              href="https://hub.docker.com/r/gremlin/gremlin"
              type="contrast"
            >
              the Docker image on DockerHub
            </OnboardingLink>
            .
          </SectionTitle>
        </div>
      </div>
    </div>
  </CodeWrapper>
)

DockerImage.propTypes = {
  colorTheme: PropTypes.oneOf(['light', 'dark'])
}

export default DockerImage
